import getLogger from "../../logger/index";
import axios from "axios";
import { config } from "api/config";
import { buildPropertyParams } from "../../util/map_list";
const log = getLogger("HESTIA_SRP_REQUEST");
export const HESTIA_SRP_REQUEST = "HESTIA_SRP_REQUEST";
export const HESTIA_SRP_SUCCESS = "HESTIA_SRP_SUCCESS";
export const HESTIA_SRP_FAILURE = "HESTIA_SRP_FAILURE";

export const REQUESTING = "Requesting";
export const SUCCESS = "Success";
export const ERROR = "Error";
import { post } from "util/apiRequest";
import { getDynamicRoute } from "util/createProfileIdPath";

export function hestiaSRPRequest() {
  return {
    type: HESTIA_SRP_REQUEST,
    status: REQUESTING,
  };
}
export function hestiaSRPSuccess(hestiaSRPData) {
  return {
    type: HESTIA_SRP_SUCCESS,
    status: SUCCESS,
    hestiaSRPData,
  };
}
export function hestiaSRPFailure(error) {
  return {
    type: HESTIA_SRP_FAILURE,
    status: ERROR,
    error,
  };
}

export function hestiaSRP(agentsData, postal_code, city, state_code) {
  return async (dispatch) => {
    let boundaryData;
    try {
      let url;

      if (postal_code != null && postal_code != "") {
        url = `https://map-api-v4.rdc.moveaws.com/api/Data/AreaByName?client_id=RDC&name=${postal_code}&type=zipCode`;
      } else if (city != null && city != "" && state_code != null && state_code != "") {
        url = `https://map-api-v4.rdc.moveaws.com/api/Data/AreaByName?client_id=RDC&name=${city}&state=${state_code}&type=city`;
      }

      const result = await axios.get(url);

      boundaryData = result.data.list;
    } catch (e) {
      log.error("Error while fetching PARSER_REQUEST data", e);
    }

    // console.log("agentsData", agentsData);

    const hestiaQuery = buildPropertyParams(agentsData && agentsData, boundaryData && boundaryData);

    const agents =
      hestiaQuery && hestiaQuery[0] && hestiaQuery[0].query && hestiaQuery[0].query.agents;
    const agentsfulfill =
      hestiaQuery && hestiaQuery[1] && hestiaQuery[1].query && hestiaQuery[1].query.fulfillment_id;
    const boundary_data =
      hestiaQuery &&
      hestiaQuery[0] &&
      hestiaQuery[0].query.boundary &&
      hestiaQuery[0].query.boundary[0] &&
      hestiaQuery[0].query.boundary[0].boundary;

    const type = boundary_data && boundary_data.type;
    const boundary = boundary_data && boundary_data.coordinates;
    const max = hestiaQuery && hestiaQuery[0].query && hestiaQuery[0].query.sold_date.max;
    const min = hestiaQuery && hestiaQuery[0].query && hestiaQuery[0].query.sold_date.min;
    dispatch(hestiaSRPRequest());
    try {
      const url = `${config.GATEWAY_URL}/${getDynamicRoute()}/api/v3/listingsSRP`;
      const body = {
        agents,
        boundary,
        type,
        min,
        max,
        agentsfulfill,
      };

      const checkToCallHestia =
        agents && agents.length > 0 && boundary_data && type && boundary ? true : false;
      const listings = checkToCallHestia ? await post(url, body, 10000) : [];
      // console.log("listings---------", listings);
      const resultJson = listings;
      resultJson.boundaryData = boundaryData;
      if (resultJson.error) {
        throw new Error(resultJson.error);
      }
      return dispatch(hestiaSRPSuccess(resultJson));
    } catch (e) {
      log.error("Error while fetching HESTIA_SRP_REQUEST data", e);
      dispatch(hestiaSRPFailure(e.message));
    }
  };
}
